const userUpdate = () => import('@/views/Home/userUpdate')
const Home = () => import('@/views/Home/home')

/**
* hidden: true                   是否显示在侧栏上
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
**/

export default [
  {
    path: '/home',
    name: 'home',
    component: Home,
    hidden: true,
    meta: {
      sort: 20,
      modules: 'home',
    },
    children: [
      {
        path: 'userUpdate',
        name: 'userUpdate',
        component: userUpdate,
        meta: {
          hidden: true,
        },
      },
    ],
  },
]
